
import { css } from 'lit';
export default css`
:host{
  --pc-insight-hero-text-color:var(--primary-white);
  --pc-insight-hero-left-width:57.265625%;
  --pc-insight-hero-right-width:42.734375%;
  --pc-insight-hero-left-background-color:var(--neutral-dark-eggplant);
  --pc-insight-hero-right-background-color:var(--primary-white);
  --pc-insight-hero-background-color:linear-gradient(
    to right,
    var(--pc-insight-hero-left-background-color) 0%,
    var(--pc-insight-hero-left-background-color) 57.265625%,
    var(--pc-insight-hero-right-background-color) 57.265625%,
    var(--pc-insight-hero-right-background-color) 100%
  );
  --pc-insight-hero-background-color-mobile:var(
    --pc-insight-hero-left-background-color
  );

  display:block;
  overflow:hidden;
}
  @media print{:host{
    --pc-insight-hero-background-color-mobile:transparent;
    --pc-insight-hero-left-background-color:var(--neutral-light);
    --pc-insight-hero-text-color:var(--neutral-dark-eggplant);
}

    :host .left-side{
      background-color:var(--neutral-light);
      padding-top:0px;
    }
  }
  :host {
  -webkit-print-color-adjust:exact;
  print-color-adjust:exact;
}

:host([loaded]) .left-side{
    opacity:1;
  }

:host([loaded]) .content{
    transform:translateY(0px);
  }

:host([loaded]) ::slotted([slot='metadata']){
    height:100%;
  }

pc-animation{
  position:absolute;
  right:0;
  bottom:0;
  height:100%;
  transition:all ease-in-out 0.3s;
  display:none;
}

@media (min-width: 992px){

pc-animation{
    display:block;
    bottom:-16%;
    right:-60%;
    left:45%
}
  }

@media (min-width: 1440px){

pc-animation{
    right:-10%;
    left:-10%;
    bottom:0
}
  }

@media (min-width: 1920px){

pc-animation{
    right:0;
    left:-25%;
    top:0px
}
  }

.insight-hero{
  background-color:var(--pc-insight-hero-background-color-mobile);
}

pc-container{
  display:flex;
  flex-direction:column-reverse;
}

.left-side{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-8);
  padding-top:var(--spacing-8);
  padding-bottom:var(--spacing-8);
  color:var(--pc-insight-hero-text-color);
  transition:opacity 1s ease-in-out;
  opacity:0;
}

.content{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-4);
  transform:translateY(10px);
  transition:all ease-in-out 0.6s;
}

@media print{

.content{
    flex-direction:column-reverse
}

  }

::slotted([slot='metadata']){
  display:flex;
  flex-wrap:wrap;
  align-items:center;
  gap:var(--spacing-4);
  height:25%;
  transition:height linear 0.4s;
  overflow:hidden;
}

.right-side{
  margin-right:calc(var(--spacing-8) * -1);
  margin-left:calc(var(--spacing-8) * -1);
  height:100%;
  position:relative;
}

.right-side ::slotted(img){
  width:100%;
  max-height:220px;
  object-fit:cover;
}

@media print, (min-width: 992px){
  .insight-hero{
    background:var(--pc-insight-hero-background-color);
  }

  pc-container{
    display:grid;
    grid-template-columns:var(--pc-insight-hero-left-width) var(
        --pc-insight-hero-right-width
      );
    border-radius:0 0 var(--spacing-8) 0;
    overflow:hidden;
  }

  .left-side{
    gap:var(--spacing-16);
    padding-top:var(--spacing-16);
    padding-bottom:var(--spacing-16);
  }

  .content{
    margin-right:var(--spacing-8);
    max-width:624px;
  }

  .right-side{
    margin-right:0;
    margin-left:0;
    background-color:var(--pc-insight-hero-left-background-color);
  }

  .right-side ::slotted(img){
    width:auto;
    height:100% !important;
    max-height:100%;
  }
}

@media print{
  pc-animation{
    display:block;
    bottom:-16%;
    right:-60%;
    left:45%;
  }
}

@media (min-width: 1440px){
  .right-side{
    background-size:120%;
  }
}
`;